// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2npG7","selects":"Documents_selects__oQMp8"};